(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["minireve-store"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initMinireve = (root) => {
      if (root.dataset.ready === 'true') return;
      root.dataset.ready = 'true';
      const topbar = root.querySelector('[data-topbar]');
      const stickyBar = root.querySelector('[data-sticky-buy]');
      const mainPurchase = root.querySelector('[data-main-purchase]');
      let purchaseObserver;
      if (stickyBar) root.classList.add('mc-has-sticky-buy');
      const observePurchase = () => {
        if (!stickyBar || !mainPurchase) return;
        purchaseObserver?.disconnect();
        const topInset = Math.ceil(topbar?.getBoundingClientRect().height || 0);
        purchaseObserver = new IntersectionObserver(([entry]) => {
          stickyBar.hidden = entry.intersectionRatio >= 0.99 && !stickyBar.contains(document.activeElement);
        }, { rootMargin: `-${topInset}px 0px -84px 0px`, threshold: [0, 0.99, 1] });
        purchaseObserver.observe(mainPurchase);
      };
      document.addEventListener('shopify:section:unload', (event) => {
        if (event.target.contains(root)) purchaseObserver?.disconnect();
      });
      const launchBanner = root.querySelector('[data-launch-banner]');
      const dismissLaunch = root.querySelector('[data-dismiss-launch]');
      const dismissalKey = 'minireve-launch-banner-dismissed-v1';
      let launchDismissed = false;
      const syncLaunchBanner = () => {
        if (launchBanner) launchBanner.hidden = launchDismissed || launchBanner.dataset.hasDiscount !== 'true';
      };
      const updateTopbarHeight = () => {
        if (topbar) root.style.setProperty('--mc-topbar-height', `${Math.ceil(topbar.getBoundingClientRect().height)}px`);
        observePurchase();
      };
      if (launchBanner) {
        try {
          launchDismissed = sessionStorage.getItem(dismissalKey) === 'true';
        } catch (error) {}
        syncLaunchBanner();
      }
      if (dismissLaunch && launchBanner) dismissLaunch.addEventListener('click', () => {
        launchDismissed = true;
        syncLaunchBanner();
        try { sessionStorage.setItem(dismissalKey, 'true'); } catch (error) {}
        updateTopbarHeight();
        root.querySelector('.mr-brand')?.focus({ preventScroll: true });
      });
      updateTopbarHeight();
      if (topbar) {
        const topbarObserver = new ResizeObserver(updateTopbarHeight);
        topbarObserver.observe(topbar);
        document.addEventListener('shopify:section:unload', (event) => {
          if (event.target.contains(root)) topbarObserver.disconnect();
        });
      }
      const main = root.querySelector('[data-gallery-main]');
      const buttons = root.querySelectorAll('[data-gallery-button]');
      buttons.forEach((button) => button.addEventListener('click', () => {
        if (!main) return;
        main.classList.remove('mr-crop-one', 'mr-crop-two', 'mr-crop-three');
        main.classList.add(button.dataset.frame);
        const image = main.querySelector('img');
        if (image) image.alt = button.dataset.alt;
        buttons.forEach((item) => item.setAttribute('aria-pressed', String(item === button)));
      }));
      const variants = root.querySelectorAll('[data-variant-radio]');
      const stickySize = root.querySelector('[data-sticky-size]');
      const priceNodes = root.querySelectorAll('[data-product-price]');
      const compareNodes = root.querySelectorAll('[data-compare-price]:not([data-variant-radio])');
      const updatePriceCopy = (attribute, value) => {
        root.querySelectorAll(`[${attribute}]:not([data-variant-radio])`).forEach((node) => {
          node.textContent = value || '';
        });
      };
      const selectVariant = (selected) => {
        if (!selected?.checked) return;
        const hasDiscount = Boolean(selected.dataset.comparePrice);
        priceNodes.forEach((node) => { node.textContent = selected.dataset.price; });
        if (stickySize) stickySize.textContent = selected.dataset.title;
        compareNodes.forEach((node) => {
          node.textContent = selected.dataset.comparePrice || '';
          node.hidden = !hasDiscount;
          node.setAttribute('aria-label', selected.dataset.compareLabel || '');
        });
        updatePriceCopy('data-discount-percent', selected.dataset.discountPercent);
        updatePriceCopy('data-discount-label', selected.dataset.discountLabel);
        updatePriceCopy('data-saving-label', selected.dataset.savingLabel);
        updatePriceCopy('data-saving-note', selected.dataset.savingNote);
        updatePriceCopy('data-hero-offer', selected.dataset.heroOffer);
        root.querySelectorAll('[data-discount-content]').forEach((node) => { node.hidden = !hasDiscount; });
        root.querySelectorAll('[data-discount-art]').forEach((node) => {
          node.hidden = !hasDiscount || node.dataset.discountArt !== selected.dataset.discount;
        });
        const ticketArt = root.querySelector('.mc-promo-ticket-art');
        const discountFallback = root.querySelector('[data-discount-fallback]');
        if (discountFallback) discountFallback.hidden = Boolean(ticketArt && !ticketArt.hidden);
        const footerArt = root.querySelector('.mc-footer-milo');
        root.querySelector('[data-offer-ending]')?.classList.toggle('mc-ending-with-milo', Boolean(footerArt && !footerArt.hidden));
        if (launchBanner) launchBanner.dataset.hasDiscount = String(hasDiscount);
        syncLaunchBanner();
        updateTopbarHeight();
      };
      variants.forEach((variant) => {
        variant.addEventListener('change', () => selectVariant(variant));
        variant.addEventListener('invalid', () => {
          root.querySelector('[data-size-fieldset]')?.scrollIntoView({ block: 'center', behavior: 'auto' });
        });
        if (variant.checked) selectVariant(variant);
      });
      const quantity = root.querySelector('input[name="quantity"]');
      const decrease = root.querySelector('[data-quantity-step="-1"]');
      const syncQuantity = () => {
        if (decrease) decrease.disabled = Number(quantity.value) <= 1;
      };
      root.querySelectorAll('[data-quantity-step]').forEach((button) => {
        button.addEventListener('click', () => {
          quantity.value = Math.max(1, (Number(quantity.value) || 1) + Number(button.dataset.quantityStep));
          quantity.dispatchEvent(new Event('change', { bubbles: true }));
        });
      });
      quantity?.addEventListener('change', syncQuantity);
    };
    const initAll = () => document.querySelectorAll('[data-minireve]').forEach(initMinireve);
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll, { once: true });
    else initAll();
    document.addEventListener('shopify:section:load', initAll);
  })();

  } catch(e) { console.error(e); }
})();
})();
